<div class="datnek-ds-dialog-body dialog-delete-group">
  <div class="content-modal">
    <div class="notif-box p-3">
      <p>
        Voulez-vous vraiment supprimer LE CLUB DES EXPERTS ANGULARJS ? Tout le
        contenu du groupe, les posts, les membres seront tous supprimé
        définitvement.
      </p>
    </div>
  </div>
  <div class="datnek-ds-dialog-footer">
    <datnek-ds-button
      [label]="'Annuler'"
      [size]="sizeEnum.large"
      [type]="colorEnum.secondary"
      class="mr-3"
      (datnekdsClickOrTouch)="close()"
    ></datnek-ds-button>
    <datnek-ds-button
      [label]="'Supprimer le groupe'"
      [size]="sizeEnum.large"
      [type]="colorEnum.danger"
      (datnekdsClickOrTouch)="close()"
    ></datnek-ds-button>
  </div>
</div>
